export default __webpack_public_path__ + "static/media/AvenirNextCyr-Regular.3ae7af43.eot";